import * as Sentry from "@sentry/angular";

import { environment } from "./environments/environment";
import { bootstrapApplication, BrowserModule } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import {
    provideTranslateLoader,
    provideTranslateService,
    TranslatePipe,
    TranslateService,
    TranslateStore,
} from "@ngx-translate/core";
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from "@angular/common/http";
import { IonicRouteStrategy, Platform, provideIonicAngular } from "@ionic/angular/standalone";
import { routes } from "./app/app.routes";

import { DatePipe } from "@angular/common";

import { PreloadAllModules, provideRouter, RouteReuseStrategy, withPreloading } from "@angular/router";
import { provideTranslateHttpLoader, TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ErrorHandler, provideZoneChangeDetection } from "@angular/core";

(window as any).global = window;

/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
(window as any).__Zone_disable_customElements = true;

Sentry.init({
    dsn: "https://ff629621dc334c24bebe7803bfc81787@o1148737.ingest.sentry.io/6605482",
    environment: environment.NAME,
    tracesSampleRate: 0.7,
    enabled: environment.production,
    ignoreErrors: [
        /Non-Error exception captured/gi,
        /not implemented/gi,
        /not available/gi,
        /cannot set keyboard style/gi,
        /ExpressionChangedAfterItHasBeenCheckedError/gi,
    ],
    integrations: [Sentry.browserTracingIntegration()],
});

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        TranslateService,
        TranslatePipe,
        TranslateStore,
        Platform,
        BrowserModule,
        DatePipe,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
        provideIonicAngular({
            backButtonText: "",
            swipeBackEnabled: false,
            mode: "ios",
            useSetInputAPI: true,
        }),
        provideRouter(routes, withPreloading(PreloadAllModules)),
        provideTranslateService({
            fallbackLang: "en",
            loader: provideTranslateLoader(TranslateHttpLoader),
        }),
        provideTranslateHttpLoader({
            prefix: "./assets/i18n/",
            suffix: ".json",
        }),
    ],
}).catch((err) => console.log(err));
